export default {
	'18_24': 'Entre 18 y 24 años',
	'25_30': 'Entre 25 y 30 años',
	'31_40': 'Entre 31 y 40 años',
	'41_50': 'Entre 41 y 50 años',
	'51_60': 'Entre 51 y 60 años',
	'60_plus': 'Más de 60 años',
	you_dont_have_this_badge_yet: 'Aún no tienes esta insignia',
	you_got_this_badge_on: 'Tienes esta insignia en',
	accept_terms_and_conditions: 'Aceptar términos y condiciones',
	accept_terms: 'Aceptar términos',
	access_the_website_from_the: 'Accede a tu perfil del',
	activity_feed: 'Feed de Actividad',
	age: 'Años',
	approved: 'Aprobado',
	are_you_a_painter: '¿Eres pintor?',
	avatar_photo_optional: 'Avatar/Foto (opcional)',
	awaiting_approval: 'Aguardando aprobación',
	birthday: 'Cumpleaños',
	birthday_date: 'date de naissance',
	birthday_date_hint:
	'Para cambiarlo, es necesario editar todos los datos (año/mes/día).',
	born_in: 'Cumpleaños en',
	branch: 'Tienda',
	brand: 'Marca',
	cellphone: 'Teléfono móvil',
	change_avatar: 'Cambiar avatar',
	change_phone: 'Cambiar teléfono',
	verification_code_sent: 'Código de verificación enviado',
	error_sending_verification_code: 'Error al enviar el código de verificación',
	change_password: 'Cambiar contraseña',
	children: 'Hijos',
	city: 'Ciudad',
	commercial_phone: 'Teléfono comercial',
	company_agency: 'Empresa/Agencia',
	complement: 'Complemento ',
	communication_phone: 'Teléfono de comunicación',
	confirm_password: 'Confirmar contraseña',
	contact_information: 'Información del contacto',
	country: 'País',
	current_password: 'Contraseña actual',
	delivered: 'Entregado',
	document_not_unique: 'Documento ya usado',
	each_level_has_exclusive_benefits_check_out_the:
		'Échale un vistazo a los benefícios de cada nível del programa.',
	email_confirm: 'Confirmar correo',
	email_dont_match: 'Los correos no coinciden',
	email_receipt_change_successfully_changed:
		'El cambio de recibo de correo electrónico se modificó correctamente',
	error_changing_password_check_your_current_password_or_try_again_later:
		'Error al cambiar la contraseña Verifique su contraseña actual o intente nuevamente más tarde',
	event_checkin: 'Check-in en el evento',
	event_qrcode_checkin: 'Evento',
	female: 'Femenino',
	file_upload_reproval: 'Carga de foto rechazada',
	file_upload: 'Carga de foto',
	from: 'de',
	gender: 'Género',
	general: 'General',
	gmin_number: 'Número GMIN',
	go_to_reward_store: 'Ir a la Tienda de Recompensas ',
	handicap_description: 'Descripción de la necesidad especial',
	i_agree_to_receive_interesting_emails_and_recommendations:
		'Acepto recibir correos electrónicos y recomendaciones interesantes',
	i_wish_to_receive_emails_from_intel_rewards_you_program:
		'Deseo recibir comunicaciones por correo electrónico del programa Intel Te Premia',
	inbox: 'Mensajes',
	information: 'OJO',
	intel_retail_edge_program: 'Programa Intel® Retail Edge',
	invalid_phone: 'Número de teléfono inválido',
	is_handicapped: '¿Con necesidades especiales?',
	justification: 'Justificación',
	kdv_code: 'Código CADV',
	last_name: 'Apellido',
	level_up: 'Upgrade',
	male: 'Masculino',
	marital_status: 'Estado Civil',
	message: 'Mensaje',
	mobile_phone: 'Teléfono celular',
	more_than: 'más de',
	my_data: 'Mis datos',
	my_points: 'Mis Puntos',
	name: 'Nombre',
	neighborhood: 'Barrio',
	new_password: 'Nueva contraseña',
	nickname: 'Apodo',
	no_address_found: 'Ninguna dirección encontrada',
	no_certificates_available: 'Niguno certificado encontrado',
	no_events_in_your_activity_feed_come_back_later:
		'No hay eventos en tu feed de actividad. Vuelve mas tarde.',
	number_of_children: 'Numero de niños',
	number: 'Número',
	open_points_history: 'Abrir historial de puntos',
	open_points_statement: 'Consultar extracto de puntos',
	order_history: 'Histórico del pedido',
	order: 'Pedido',
	orders: 'Mis Canjes',
	others: 'Otros',
	painter: 'Pintor',
	password_changed_successfully: 'Contraseña alterada con éxito',
	past_months: 'Meses anteriores',
	personal_information: 'Información Personal',
	phone_number: 'Teléfono',
	phone: 'Teléfono',
	phone_verified: 'Teléfono verificado',
	phone_not_verified: 'Teléfono no verificado. Verifique el mensaje de validación del número en su WhatsApp.',
	phone_social_information: 'Confirmación requerida',
	phone_to_receive_notifications: 'Número de teléfono para recibir notificaciones.',
	phone_to_receive_notifications_promotions_and_account_settings: 'Número de teléfono para recibir notificaciones, invitaciones y recuperación de cuenta.',
	points_earned_during_the_campaign: 'Puntos acumulados durante la campaña',
	profession: 'Profesión',
	professional_information: 'Información Profesional',
	profile_edited_successfully: 'Perfil editado con éxito',
	profile_successfully_changed: 'Perfil cambiado correctamente',
	program_rule: 'Reglas del programa',
	redeem: 'Canje',
	resend_verification: 'Reenviar verificación',
	register: 'Registro',
	reject_terms: 'Rechazar términos',
	reproved: 'Reprobado',
	residential_phone: 'Teléfono residencial',
	retailer: 'Cadena Minorista',
	sale_reproval: 'Venta rechazada',
	sale: 'Venta',
	search_address: 'Buscar dirección',
	search_by_street_name_and_number: 'Búsqueda por calle y número',
	see_all_badges: 'Ver todas las medallas',
	see_all_certificates: 'Ver todos los certificados',
	see_the_full_ranking: 'Ver el ranking completo',
	select_profile: 'Seleccionar perfil',
	shipped: 'Enviado',
	show_ranking: 'Ver ranking',
	state: 'Estado',
	statement: 'Declaración',
	store_nickname: 'Apodo en tienda (opcional)',
	there_are_no_messages_available_at_the_moment: 'No tienes mensajes en el momento.',
	these_data_cannot_be_changed: 'Estos datos no se pueden cambiar.',
	this_campaign: 'Esta Campaña',
	to_change_the_information_bellow: 'si deseas cambiar tus datos personales.',
	to: 'hasta',
	total_credits_available_to_spend: 'Total de puntos disponibles para canjes',
	training_special: 'Bono de formación obligatoria',
	type_photo_upload: 'escribe la foto subida',
	undefined: 'Prefiero no revelar',
	user_avatar_changed: 'Tu avatar se ha cambiado correctamente',
	user_level_up: 'El usuario subió de nivel',
	user_registered: 'Usuario registrado',
	wait: 'Espere',
	we_couldnt_find_any_messages_with_the_current_search:
		'No hemos localizado nungún mensaje en esta búsqueda.',
	whats_your_profession: '¿Cual es tu profesión?',
	whatsapp: 'Whatsapp',
	you_dont_have_any_points_yet: 'Aún no tienes puntos',
	you_dont_have_certificates_in_this_category: 'Aún no tienes certificados en esta categoría',
	you_have: 'tienes',
	your_account_has_been_created_and_is_awaiting_for_aproval_you_will_receive_an_email:
		'Su cuenta ha sido creada y está pendiente de aprobación. Recibirás un correo electrónico con instrucciones pronto.',
	your_account_has_been_created_verify_your_email_for_instructions:
		'Su cuenta ha sido creada. Verifique su e-mail para instrucciones.',
	your_password_must_contain_at_least_characters_uppercase_letters_lowercase_letters_numbers_and_symbols:
		'Su contraseña debe contener al menos 6 caracteres, letras mayúsculas, letras minúsculas, números y símbolos {symbols}',
	your_password_must_contain_at_least_characters_uppercase_letters_lowercase_letters_numbers:
		'Su contraseña debe contener al menos 6 caracteres, letras mayúsculas, letras minúsculas, números',
	your_password_must_contain_at_least_characters:
		'Su contraseña debe contener al menos 6 caracteres.',
	your_ranking_position_will_be_available_after_you_complete_at_least_one_course:
		'Su posición en el ranking estará disponible después de completar al menos un curso.',
	find_your_network: 'Encuentra tu red',
	select_your_branch: 'Selecciona tu sucursal',
}
